var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools01-copy-detail"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("フォーマット一覧")])])],1),_c('FormatList',{attrs:{"type":0,"toolId":_vm.copyPageToolId,"pageId":_vm.copyPageId,"buttonName":'コピー'},on:{"formatDecide":_vm.copyFormatData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }